import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface KpiCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon?: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  testId?: string;
}

export function KpiCard({ title, value, subtitle, icon: Icon, trend, className, testId }: KpiCardProps) {
  return (
    <Card className={cn("", className)}>
      <CardContent className="p-6">
        <div className="flex items-start justify-between gap-2">
          <div className="space-y-1 min-w-0 overflow-hidden">
            <p className="text-sm font-medium text-muted-foreground truncate">{title}</p>
            <p data-testid={testId} className="text-2xl font-bold tracking-tight truncate">{value}</p>
            {subtitle && (
              <p className="text-xs text-muted-foreground truncate">{subtitle}</p>
            )}
            {trend && (
              <p className={cn(
                "text-xs font-medium truncate",
                trend.isPositive ? "text-green-600" : "text-red-600"
              )}>
                {trend.isPositive ? "+" : ""}{trend.value}% vs poprzedni okres
              </p>
            )}
          </div>
          {Icon && (
            <div className="rounded-lg bg-muted p-2.5 flex-shrink-0">
              <Icon className="h-5 w-5 text-muted-foreground" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
